import React from 'react'

export default function NoPermission() {
  return (
    <div>NoPermission</div>
  )
}
